import { Directive, TemplateRef, inject } from '@angular/core';
import type { QpxOverflowInlineItemTemplateContext } from './models';

@Directive({
    selector: 'ng-template[qpxOverflowInlineItemTpl]',
})
export class QpxOverflowInlineItemTemplate {
    public readonly templateRef =
        inject<TemplateRef<QpxOverflowInlineItemTemplateContext>>(TemplateRef);

    static ngTemplateContextGuard(
        _dir: QpxOverflowInlineItemTemplate,
        _ctx: unknown
    ): _ctx is QpxOverflowInlineItemTemplateContext {
        return true;
    }
}
